var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustry01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230.85 189.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M127.42,149.32a3.63,3.63,0,0,0,3.62,3.62h7.24a3.63,3.63,0,0,0,3.62-3.62V87.78H127.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "currentColor",
    d: "M135.86,40.3a7.29,7.29,0,0,0-6.05-3.21H38.13a7.21,7.21,0,0,0-6,3.21l-19.3,29a7.24,7.24,0,0,0,6,11.27H149.14a7.26,7.26,0,0,0,6-11.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M84,124H40.53V87.78H26.05V145.7a7.23,7.23,0,0,0,7.24,7.24H91.21a7.23,7.23,0,0,0,7.24-7.24V87.78H84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "currentColor",
    d: "M213.23,44.91H196.39L202.6,26a3.51,3.51,0,0,0-3.38-4.4h-21a3.5,3.5,0,0,0-3.47,3l-4.67,35a3.51,3.51,0,0,0,3.47,4h17.33L184.13,92a3.49,3.49,0,0,0,6.43,2.55l25.69-44.36A3.49,3.49,0,0,0,213.23,44.91Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry01);
export default __webpack_public_path__ + "static/media/industry_01.7f2fb0a2.svg";
export { ForwardRef as ReactComponent };